/** Generated by packages/core/scripts/generate-i18n-locales.ts — do not edit. */

import { registerI18n } from '@videojs/core/i18n';
import { all } from '@videojs/core/i18n/locales/all';

for (const [tag, translations] of Object.entries(all)) {
  registerI18n(tag, translations);
}
